import React, { useState } from 'react';

const GD = '#8B6914';

export default function FeedbackSection({ reportId, reportType, api }) {
  const [rating, setRating] = useState(null);
  const [corrections, setCorrections] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  const [expanded, setExpanded] = useState(false);

  const addCorrection = () => {
    setCorrections([...corrections, { claim: '', actual: '', reason: '' }]);
    setExpanded(true);
  };

  const updateCorrection = (i, field, val) => {
    const updated = [...corrections];
    updated[i][field] = val;
    setCorrections(updated);
  };

  const submit = async () => {
    const body = {
      report_id: reportId,
      report_type: reportType,
      rating,
      corrected_fact: corrections.filter(c => c.claim && c.actual),
    };
    try {
      const res = await fetch(`${api}/audit/feedback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify(body),
      });
      if (res.ok) setSubmitted(true);
    } catch (e) {
      console.error('Feedback submit error:', e);
    }
  };

  if (submitted) {
    return (
      <div style={{ padding: '24px 0', textAlign: 'center', color: GD, fontSize: 14 }}>
        感谢反馈 🙏 下次解读将引用您的校准数据
      </div>
    );
  }

  return (
    <div style={{
      maxWidth: 640, margin: '40px auto', padding: '20px 24px',
      background: 'rgba(139,105,20,0.04)', borderRadius: 12,
      border: '1px solid rgba(139,105,20,0.1)',
    }}>
      <div style={{ fontSize: 14, color: '#555', marginBottom: 12 }}>
        本次解读是否准确？
      </div>
      <div style={{ display: 'flex', gap: 10, marginBottom: 12 }}>
        {[
          { key: 'accurate',   label: '👍 准确',    color: '#4a7c59' },
          { key: 'partial',    label: '🤔 部分准确', color: '#8B6914' },
          { key: 'inaccurate', label: '👎 不准确',   color: '#a04040' },
        ].map(opt => (
          <button key={opt.key}
            onClick={() => { setRating(opt.key); setExpanded(true); }}
            style={{
              padding: '8px 16px', borderRadius: 8, cursor: 'pointer',
              border: rating === opt.key ? `1.5px solid ${opt.color}` : '1px solid #ddd',
              background: rating === opt.key ? `${opt.color}10` : '#fff',
              color: rating === opt.key ? opt.color : '#777',
              fontSize: 13, transition: 'all 0.15s',
            }}>
            {opt.label}
          </button>
        ))}
      </div>

      {expanded && (
        <div style={{ marginTop: 12 }}>
          {corrections.map((c, i) => (
            <div key={i} style={{
              marginBottom: 10, padding: '10px 12px',
              background: '#fff', borderRadius: 8,
              border: '1px solid rgba(139,105,20,0.08)',
            }}>
              <input
                placeholder="哪部分不对？如「2018年事业低谷」"
                value={c.claim}
                onChange={e => updateCorrection(i, 'claim', e.target.value)}
                style={{
                  width: '100%', padding: '6px 8px', border: '1px solid #eee',
                  borderRadius: 4, fontSize: 13, marginBottom: 6, boxSizing: 'border-box',
                }}
              />
              <input
                placeholder="实际是什么？如「实际是升职」"
                value={c.actual}
                onChange={e => updateCorrection(i, 'actual', e.target.value)}
                style={{
                  width: '100%', padding: '6px 8px', border: '1px solid #eee',
                  borderRadius: 4, fontSize: 13, boxSizing: 'border-box',
                }}
              />
            </div>
          ))}
          <button onClick={addCorrection}
            style={{
              padding: '4px 10px', fontSize: 12, color: GD,
              background: 'none', border: '1px dashed rgba(139,105,20,0.2)',
              borderRadius: 4, cursor: 'pointer',
            }}>
            + 添加更多
          </button>

          <div style={{ marginTop: 14, textAlign: 'right' }}>
            <button onClick={submit}
              disabled={!rating}
              style={{
                padding: '8px 20px', borderRadius: 8,
                cursor: rating ? 'pointer' : 'not-allowed',
                background: rating ? GD : '#ccc', color: '#fff',
                border: 'none', fontSize: 13, opacity: rating ? 1 : 0.5,
              }}>
              提交反馈
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
